import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authHeaders, axiosInstance, logError } from '../../utils/helper';
import { centerLocation } from '../../utils/constants';

const initialState = {
	savedIsOpen: false,
	savedIsOnSearch: false,
	// savedInitialForm: null, // untuk
	// savedSearchResult: null,

	savedData: [],
	savedLoading: false,

	// savedFormLoading: false,

	recentData: [],
	recentLoading: false,

	isOpenDeliveryLocation: false,
	isShowFormAddress: false,
	isShowGoogleMaps: false,

	formAddress: {
		addressName: null,
		detail: null,
		addressType: 'home',
		firstName: null,
		primaryPhone: null,
		latitude: null,
		longitude: null,
		address: null,
		district: null,
		village: null,
    postalCode: null,
		email: null,
		zoom: 4,
		center: centerLocation,
	},
};

export const getSavedList = createAsyncThunk('location/getSavedList', async () => {
	const formData = new FormData();
	formData.append('limit', null);

	const res = await axiosInstance.post('address/list', formData, authHeaders());
	const data = await res.data;
	return data;
});

export const getRecentList = createAsyncThunk('location/getRecentList', async () => {
	const formData = new FormData();

	const res = await axiosInstance.post('address/list-history', formData, authHeaders());
	const data = await res.data;
	return data;
});

const location = createSlice({
	name: 'location',
	initialState,
	reducers: {
		setLocation: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearSearch: (state) => {
			return {
				...state,
				savedIsOpen: false,
				savedIsOnSearch: false,
				savedInitialForm: null,
				savedSearchResult: null,
			};
		},
		clearLocation: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getSavedList.pending, (state) => {
				state.savedLoading = true;
			})
			.addCase(getSavedList.fulfilled, (state, action) => {
				state.savedLoading = false;
				state.savedData = action.payload.data;
			})
			.addCase(getSavedList.rejected, (state, action) => {
				state.savedLoading = false;

        // logError(new Error(action.error?.message), {
        //   feature: "getSavedList",
        //   actionType: action.type,
        // });
			})
      .addCase(getRecentList.pending, (state) => {
				state.recentLoading = true;
			})
			.addCase(getRecentList.fulfilled, (state, action) => {
				state.recentLoading = false;
				state.recentData = action.payload.data;
			})
			.addCase(getRecentList.rejected, (state, action) => {
				state.recentLoading = false;

        // logError(new Error(action.error?.message), {
        //   feature: "getRecentList",
        //   actionType: action.type,
        // });
			});
	},
});

// Export actions and reducer
export const { setLocation, clearSaved, clearSearch, clearLocation } = location.actions;
export default location.reducer;
